import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-tour-intro-dialog',
  templateUrl: './tour-intro-dialog.component.html',
  styleUrls: ['./tour-intro-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TourIntroDialogComponent {
  @Output() takeTour = new EventEmitter();

  constructor(@Inject(MAT_DIALOG_DATA) public readonly data: { title: string, message: string }) { }
}
